import './LanguageSelect.scss';
import React from 'react';
import selectDown from '../../assets/img/selectDown.svg';
import selectUp from '../../assets/img/selectUp.svg';
import OutsideHook from '../outsidehook/OutsideHook';
import planet from '../../assets/img/planet.svg';
import { useState,useEffect } from 'react';
import { Link, useLocation, useMatch } from 'react-router-dom';
import { generateLanguage } from '../../i18n';
import { whitelists } from '../../i18n';


function LanguageSelect(props) {
  const [ref, isShow,setIsShow] = OutsideHook(false);
  const location = useLocation();

  const match = useMatch('/:lang/*');

  let lang = match? 
  (whitelists.includes(match.params.lang) ? match.params.lang : null) : null ;

  const disolayLang = lang ? lang : 'ru';

  const [currentLanguage, setCurrentLanguage] = useState(disolayLang.toLocaleUpperCase());
  const setLanguage = (language) => {
    setCurrentLanguage(language.toUpperCase());
    props.onLanguageChange(language.toLowerCase());
    setIsShow(false)
  }
  
  

  const langData = ['EN','PL','UA','RU'];
    const langItem = langData
    .filter(item => item !== currentLanguage)
    .map(item => (
      <Link className="dropdown-item" key={item} to={generateLanguage(item.toLocaleLowerCase(), location)} onClick={()=>{setLanguage(item)}}>{/* а у нас разве не такой же подход ? */}
          <img className='languageSelectorImage' src={planet} alt="planet"  />
          <div className="lang-item-label" >{item}</div>
      </Link>
  ))
  return (
    <div ref ={ref} className="dropdown">
        <div className="dropdown-btn" onClick={() => {
          setIsShow(!isShow)
          }}>
          <img className='languageSelectorImage-main' src={planet} alt="planet"  /> 
          <div className="lang-itam-label">{currentLanguage}</div>
          <span className='arrow-down' ><img src={isShow ? selectUp : selectDown} alt="arrow"  /></span>
        </div>
        {isShow && (<div className="dropdown-content">
          {langItem}
        </div>)}
    </div>
  );
}

export default LanguageSelect;